module.exports = __webpack_public_path__ + "static/media/boat.b4038bf1.png";